import Indicator from "../Indicator";
import { useContext, useState } from "react";
import { ContextProfileUser } from "../../lib/profileContext";
import { validatePassword, simplyClick } from "../../helpers";
import InputGlobal from "../InputGlobal";
import ButtonGroup from "../ButtonGroup";
import checkIcon from "../../images/check.svg";
import "./Password.scss";
import Eye from "../../images/eye.svg";
import EyeOff from "../../images/eye-off.svg";
import chatIcon from "../../images/ico_data-chat-message.svg";
import confettiIcon from "../../images/ico_confetti.svg";
import LovelyIcon from "../../images/ico_lovely.svg";
import HeartsIcon from "../../images/ico_hearts.svg";
import { errorEventsPassword, joinReasons, landingId } from "../../constants";
import Tooltip from "../Tooltip";
import { useWizardAnswers } from "ui-components";
import { useAppendLandingId } from "../../hooks/useAppendLandingId";

const Password = ({ step, setStep }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [passwordShow, setPasswordShow] = useState(false);
  const [error, setError] = useState({ password: null, terms: null });
  const [checkBox, setCheckBox] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const updateAnswer = useWizardAnswers();

  useAppendLandingId(landingId);

  const handlerSubmit = () => {
    if (!selectedIndicator) {
      updateAnswer({ join_reasons: ["0"] });
    }
    const { status, error = { text: "", type: "" } } = validatePassword(
      data.password
    );

    if (error.type) {
      simplyClick(errorEventsPassword[error.type]);
    }

    if (!status) {
      setError({ ...error, password: error.text });
      return;
    }

    if (!checkBox) {
      simplyClick("err_lnd_checkbox_nocheckbox");
      setError({
        ...error,
        terms:
          "Please accept our Terms of Use, Privacy Policy, Cookie Policy, Billing & Refund Policy, Consent Policy",
      });
      return;
    }

    simplyClick("cl_lnd_cd3_password_next");
    setStep(step + 1);
  };

  const handlerAddPassword = ({ target: { value } }) => {
    setError({ ...error, password: null });
    setShowTooltip(false);
    setData({ ...data, password: value });
  };

  const handleCheckBox = () => {
    setError({ ...error, terms: null });
    setCheckBox(!checkBox);
  };

  const toggleBtn = () => {
    setPasswordShow(!passwordShow);
  };
  const handlerStepBack = () => {
    simplyClick("cl_lnd_cd3_password_back");
    setStep(step - 1);
  };

  const handleSelectIndicator = (id) => {
    const selected = joinReasons[id];

    if (!selected) {
      return;
    }
    setSelectedIndicator(selected.label);
    updateAnswer({ join_reasons: [String(id)] });

    if (selected.event) {
      simplyClick(selected.event);
    }
  };
  const handlerPasswordFocus = () => {
    setShowTooltip(true);
    simplyClick("cl_lnd_cd3_password_type_password");
  };
  const handleChekbox = () => {
    simplyClick("cl_lnd_cd3_password_checkbox_mark");
  };
  return (
    <div className="password__form">
      <h5 className="form__title">What are you looking for?</h5>
      <div className="group__top">
        <Indicator
          textLabel={joinReasons[9].label}
          iconIndicator={HeartsIcon}
          initialClassName="component-1"
          isActive={selectedIndicator === joinReasons[9].label}
          onClick={() => handleSelectIndicator(9)}
        />
        <Indicator
          textLabel={joinReasons[11].label}
          iconIndicator={confettiIcon}
          initialClassName="component-2"
          isActive={selectedIndicator === joinReasons[11].label}
          onClick={() => handleSelectIndicator(11)}
        />
        <Indicator
          textLabel={joinReasons[10].label}
          iconIndicator={chatIcon}
          initialClassName="component-3"
          isActive={selectedIndicator === joinReasons[10].label}
          onClick={() => handleSelectIndicator(10)}
        />
      </div>
      <div className="group__bottom">
        <Indicator
          textLabel={joinReasons[12].label}
          iconIndicator={LovelyIcon}
          initialClassName="component-3"
          isActive={selectedIndicator === joinReasons[12].label}
          onClick={() => handleSelectIndicator(12)}
        />
      </div>
      <span className="line" />
      <h5 className="form__title">
        Create a solid password for logging into the system:*
      </h5>
      <div className="password__box">
        <div className="password__wrapper">
          <div className="has-float-label">
            <InputGlobal
              className={
                "input__global password" + (error?.password ? " error" : "")
              }
              onChange={(e) => handlerAddPassword(e)}
              name={"password"}
              placeholder={"Enter your password"}
              type={passwordShow ? "text" : "password"}
              id={"password"}
              value={data.password ? data.password : ""}
              autoComplete="password"
              onFocus={handlerPasswordFocus}
              onBlur={() => setShowTooltip(false)}
            />
            <label
              htmlFor="password"
              className={error?.password ? " error" : ""}
            >
              Enter your password
            </label>
            {error?.password && <p className="error-text">{error?.password}</p>}
            <Tooltip
              text="Passwords must be at least 5 characters long. You can recover passwords at any time using the email address you provided."
              showTooltip={showTooltip}
              className="password"
            />
          </div>
          <button onClick={toggleBtn} className="logo__eye">
            {passwordShow ? (
              <img src={Eye} alt="icon" />
            ) : (
              <img src={EyeOff} alt="icon" />
            )}
          </button>
        </div>
        <div className="terms__wrapper">
          <label htmlFor="remember_me" className="terms__label">
            <input
              checked={checkBox}
              onChange={(e) => handleCheckBox(e)}
              onClick={handleChekbox}
              type="checkbox"
              id="remember_me"
              className={"checkBox" + (error?.terms ? " error" : "")}
              name="remember"
              value="1"
            />
            <span className="checkBox__box">
              {checkBox && <img src={checkIcon} alt="checked" />}
            </span>
            <span className="terms__inner">
              <span>I have read, understand and agree to </span>
              <span>
                <a href="/terms-of-use/" target="_blank">
                  Terms of Use,&nbsp;
                </a>
              </span>
              <span>
                <a href="/privacy-policy/" target="_blank">
                  Privacy Policy,&nbsp;
                </a>
              </span>
              <span>
                <a href="/cookie-policy/" target="_blank">
                  Cookie Policy,&nbsp;
                </a>
              </span>
              <span>
                <a href="/billing-policy/" target="_blank">
                  Billing &nbsp;
                </a>
              </span>
              <span>
                <a href="/refund-policy/" target="_blank">
                  Refund Policy,&nbsp;
                </a>
              </span>
              <span>
                <a href="/consent-policy/" target="_blank">
                  Consent Policy
                </a>
              </span>
            </span>
          </label>
          {error?.terms && <p className="error-text terms">{error?.terms}</p>}
        </div>

        <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
      </div>
    </div>
  );
};
export default Password;
